import setPreviewImageUrl from './setPreviewImageUrl';
import getAttachment from '../selectors/getAttachment';
import AttachmentModel from '../store/schema/AttachmentModel';
import TypeOfAttachment from '../store/schema/TypeOfAttachment';
import { GDRIVE, ONE_DRIVE_CONSUMER, ONE_DRIVE_PRO } from '../utils/attachmentConstants';
import getGDriveItemThumbnailUrl from '../utils/getGDriveItemThumbnailUrl';
import { isCloudyAttachmentType } from '../utils/isCloudyAttachment';
import { getAttachmentUrl } from 'owa-attachment-url';
import { ClientAttachmentId } from 'owa-client-ids';
import AttachmentUrlType from 'owa-files-url/lib/schema/AttachmentUrlType';
import ReferenceAttachment from 'owa-service/lib/contract/ReferenceAttachment';
import { action } from 'satcheljs/lib/legacy';

async function refreshGDrivePreviewImageUrl(attachment: ReferenceAttachment): Promise<string> {
    // GDrive URL must be refreshed each time because of limited lifespan
    const url = await getGDriveItemThumbnailUrl(attachment);
    if (url == null) {
        throw new Error('URL not available');
    }
    const suffixForFullResolutionImage = '2';
    const refreshedUrl = url + suffixForFullResolutionImage;

    return refreshedUrl;
}

export default action('refreshPreviewImageUrl')(async function refreshPreviewImageUrl(
    attachmentId: ClientAttachmentId,
    isReadOnly: boolean,
    addIsDownloadQueryParam: boolean = false
): Promise<void> {
    const attachment: AttachmentModel = getAttachment(attachmentId);

    if (isCloudyAttachmentType(attachment.model) && attachment.model.ProviderType === GDRIVE) {
        // For any other provider create a function
        // to get the url and call it here
        // corresponding to the provider type
        const refreshedUrl = await refreshGDrivePreviewImageUrl(attachment.model);
        setPreviewImageUrl(attachmentId, refreshedUrl);
    } else if (
        !isCloudyAttachmentType(attachment.model) ||
        attachment.model.ProviderType === ONE_DRIVE_CONSUMER ||
        attachment.model.ProviderType === ONE_DRIVE_PRO
    ) {
        const url = getAttachmentUrl(
            attachmentId,
            attachment.model,
            AttachmentUrlType.Preview,
            attachment.type === TypeOfAttachment.Reference,
            isReadOnly,
            addIsDownloadQueryParam
        );

        setPreviewImageUrl(attachmentId, url);
    }
});
